import { Component } from '@angular/core';

@Component({
  selector: 'app-card-button',
  templateUrl: './post-card-button.component.html',
})
export class PostCardButtonComponent {}
